import axios from "axios";

const bulkUpdateSnStatus = ({
  enc,
  status
}) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/serialnumber/api/v1/serialnumber/status/bulk-update`, {
        enc,
        status,
      })
      .then(response => resolve(response.data))
      .catch(error => {
        return reject(error.response.data)
      });
  });
};

export default bulkUpdateSnStatus;
